import api from './axios';

export const listar = () => api.get('/hospitais/');
export const obter = (idHospital) => api.get(`/hospitais/${idHospital}`);
export const criar = (data) => api.post('/hospitais/', data);
export const atualizar = (idHospital, data) => api.patch(`/hospitais/${idHospital}`, data);
export const iniciarTrabalho = (idHospital, dataInicioTrabalho) =>
  api.patch(`/hospitais/${idHospital}/iniciar-trabalho`, { data_inicio_trabalho: dataInicioTrabalho });
export const obterEscopo = (idHospital) => api.get(`/hospitais/${idHospital}/escopo`);
export const atualizarEscopo = (idHospital, itens) => api.patch(`/hospitais/${idHospital}/escopo`, { itens });
